/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface DisableUserNotificationRequest {
  /**
   *
   *
   * 100 = InviteToContent
   *
   * 200 = ContentActivity
   *
   * 300 = ChatMessage
   *
   * 400 = StartCall
   *
   * 500 = YouNewOwner
   *
   * 600 = YouOldOwner
   *
   * 700 = ApprovalResult
   *
   * 800 = ShareContent
   *
   * 810 = MergeContent
   *
   * 900 = AlertOwner
   *
   * 1000 = ReviewContent
   *
   * 1010 = ContentReviewResumed
   *
   * 1020 = InContentReview
   *
   * 1100 = YouNewReviewer
   *
   * 1200 = YouOldReviewer
   *
   * 1300 = ReviewCompleted
   *
   * 1310 = ReviewFeedback
   *
   * 1320 = AnswerApproved
   *
   * 1330 = AnswerRejected
   *
   * 1400 = AddUserToContent
   *
   * 1500 = AnswerQuestionReminder
   *
   * 1600 = AddUsersToFolder
   *
   * 1800 = LinkContentsApprovalResult
   *
   * 1900 = UnreadTrainingMaterialReminder
   *
   * 1910 = TrainingMaterialAssigned
   *
   * 2000 = MyCertificateExpiration
   *
   * 2005 = UserCertificateExpiration
   *
   * 2010 = QualificationExpiration
   *
   * 2020 = MyUserQualificationExpiration
   *
   * 2025 = UserQualificationExpiration
   *
   * 2030 = ContractExpiration
   *
   * 2035 = WebCallRingNotification
   */
  notificationType: NotificationTypeEnum
  tenantScoped: boolean
}

export interface EnableUserNotificationRequest {
  /**
   *
   *
   * 100 = InviteToContent
   *
   * 200 = ContentActivity
   *
   * 300 = ChatMessage
   *
   * 400 = StartCall
   *
   * 500 = YouNewOwner
   *
   * 600 = YouOldOwner
   *
   * 700 = ApprovalResult
   *
   * 800 = ShareContent
   *
   * 810 = MergeContent
   *
   * 900 = AlertOwner
   *
   * 1000 = ReviewContent
   *
   * 1010 = ContentReviewResumed
   *
   * 1020 = InContentReview
   *
   * 1100 = YouNewReviewer
   *
   * 1200 = YouOldReviewer
   *
   * 1300 = ReviewCompleted
   *
   * 1310 = ReviewFeedback
   *
   * 1320 = AnswerApproved
   *
   * 1330 = AnswerRejected
   *
   * 1400 = AddUserToContent
   *
   * 1500 = AnswerQuestionReminder
   *
   * 1600 = AddUsersToFolder
   *
   * 1800 = LinkContentsApprovalResult
   *
   * 1900 = UnreadTrainingMaterialReminder
   *
   * 1910 = TrainingMaterialAssigned
   *
   * 2000 = MyCertificateExpiration
   *
   * 2005 = UserCertificateExpiration
   *
   * 2010 = QualificationExpiration
   *
   * 2020 = MyUserQualificationExpiration
   *
   * 2025 = UserQualificationExpiration
   *
   * 2030 = ContractExpiration
   *
   * 2035 = WebCallRingNotification
   */
  notificationType: NotificationTypeEnum
  tenantScoped: boolean
}

export interface NotificationSetting {
  name: string
  description?: string | null
  /**
   *
   *
   * 100 = InviteToContent
   *
   * 200 = ContentActivity
   *
   * 300 = ChatMessage
   *
   * 400 = StartCall
   *
   * 500 = YouNewOwner
   *
   * 600 = YouOldOwner
   *
   * 700 = ApprovalResult
   *
   * 800 = ShareContent
   *
   * 810 = MergeContent
   *
   * 900 = AlertOwner
   *
   * 1000 = ReviewContent
   *
   * 1010 = ContentReviewResumed
   *
   * 1020 = InContentReview
   *
   * 1100 = YouNewReviewer
   *
   * 1200 = YouOldReviewer
   *
   * 1300 = ReviewCompleted
   *
   * 1310 = ReviewFeedback
   *
   * 1320 = AnswerApproved
   *
   * 1330 = AnswerRejected
   *
   * 1400 = AddUserToContent
   *
   * 1500 = AnswerQuestionReminder
   *
   * 1600 = AddUsersToFolder
   *
   * 1800 = LinkContentsApprovalResult
   *
   * 1900 = UnreadTrainingMaterialReminder
   *
   * 1910 = TrainingMaterialAssigned
   *
   * 2000 = MyCertificateExpiration
   *
   * 2005 = UserCertificateExpiration
   *
   * 2010 = QualificationExpiration
   *
   * 2020 = MyUserQualificationExpiration
   *
   * 2025 = UserQualificationExpiration
   *
   * 2030 = ContractExpiration
   *
   * 2035 = WebCallRingNotification
   */
  type?: NotificationTypeEnum
  isEnabled: boolean
}

/**
 *
 *
 * 100 = InviteToContent
 *
 * 200 = ContentActivity
 *
 * 300 = ChatMessage
 *
 * 400 = StartCall
 *
 * 500 = YouNewOwner
 *
 * 600 = YouOldOwner
 *
 * 700 = ApprovalResult
 *
 * 800 = ShareContent
 *
 * 810 = MergeContent
 *
 * 900 = AlertOwner
 *
 * 1000 = ReviewContent
 *
 * 1010 = ContentReviewResumed
 *
 * 1020 = InContentReview
 *
 * 1100 = YouNewReviewer
 *
 * 1200 = YouOldReviewer
 *
 * 1300 = ReviewCompleted
 *
 * 1310 = ReviewFeedback
 *
 * 1320 = AnswerApproved
 *
 * 1330 = AnswerRejected
 *
 * 1400 = AddUserToContent
 *
 * 1500 = AnswerQuestionReminder
 *
 * 1600 = AddUsersToFolder
 *
 * 1800 = LinkContentsApprovalResult
 *
 * 1900 = UnreadTrainingMaterialReminder
 *
 * 1910 = TrainingMaterialAssigned
 *
 * 2000 = MyCertificateExpiration
 *
 * 2005 = UserCertificateExpiration
 *
 * 2010 = QualificationExpiration
 *
 * 2020 = MyUserQualificationExpiration
 *
 * 2025 = UserQualificationExpiration
 *
 * 2030 = ContractExpiration
 *
 * 2035 = WebCallRingNotification
 * @format int32
 */
export enum NotificationTypeEnum {
  InviteToContent = 100,
  ContentActivity = 200,
  ChatMessage = 300,
  StartCall = 400,
  YouNewOwner = 500,
  YouOldOwner = 600,
  ApprovalResult = 700,
  ShareContent = 800,
  MergeContent = 810,
  AlertOwner = 900,
  ReviewContent = 1000,
  ContentReviewResumed = 1010,
  InContentReview = 1020,
  YouNewReviewer = 1100,
  YouOldReviewer = 1200,
  ReviewCompleted = 1300,
  ReviewFeedback = 1310,
  AnswerApproved = 1320,
  AnswerRejected = 1330,
  AddUserToContent = 1400,
  AnswerQuestionReminder = 1500,
  AddUsersToFolder = 1600,
  LinkContentsApprovalResult = 1800,
  UnreadTrainingMaterialReminder = 1900,
  TrainingMaterialAssigned = 1910,
  MyCertificateExpiration = 2000,
  UserCertificateExpiration = 2005,
  QualificationExpiration = 2010,
  MyUserQualificationExpiration = 2020,
  UserQualificationExpiration = 2025,
  ContractExpiration = 2030,
  WebCallRingNotification = 2035,
}

export interface NotificationsCategory {
  name: string
  notificationSettings: NotificationSetting[]
}

export interface UserNotificationSettingResponse {
  isEnabled: boolean
}

export interface UserNotificationSettingsResponse {
  notificationCategories: NotificationsCategory[]
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Tabeeb.NotificationsMicroservice
 * @version v1
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  userNotificationsSettings = {
    /**
     * No description
     *
     * @tags UserNotificationsSettings
     * @name GetUserNotificationSettings
     * @request GET:/notifications-service/api/user-notifications-settings
     * @secure
     */
    getUserNotificationSettings: (
      query?: {
        /** @default true */
        tenantScoped?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserNotificationSettingsResponse, void>({
        path: `/notifications-service/api/user-notifications-settings`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserNotificationsSettings
     * @name GetUserNotificationSetting
     * @request GET:/notifications-service/api/user-notifications-settings/{type}
     * @secure
     */
    getUserNotificationSetting: (
      type: NotificationTypeEnum,
      query?: {
        /** @default true */
        tenantScoped?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserNotificationSettingResponse, void>({
        path: `/notifications-service/api/user-notifications-settings/${type}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserNotificationsSettings
     * @name EnableUserNotification
     * @request PUT:/notifications-service/api/user-notifications-settings/enable
     * @secure
     */
    enableUserNotification: (data: EnableUserNotificationRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/notifications-service/api/user-notifications-settings/enable`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserNotificationsSettings
     * @name DisableUserNotification
     * @request PUT:/notifications-service/api/user-notifications-settings/disable
     * @secure
     */
    disableUserNotification: (data: DisableUserNotificationRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/notifications-service/api/user-notifications-settings/disable`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
}
